<!--
  The employment waiting screen (#864). Same frame as the two-factor screen (`max-w-3xl mx-auto`, `px-4 sm:px-6`,
  a white card that is edge-to-edge on phones and rounded from `sm`), so the four lockout screens look like one
  family. No navigation beyond the two task buttons: the guard would bounce any other link straight back here.
-->
<div class="mx-auto max-w-3xl px-4 py-8 sm:px-6">
  <div class="overflow-hidden bg-white shadow sm:rounded-lg">
    <div class="px-4 py-6 sm:px-6">
      <h1 class="text-lg font-semibold text-gray-900">Ihre Beschäftigung hat noch nicht begonnen</h1>
      @if (startsAt(); as start) {
        <p class="mt-2 text-sm text-gray-700" data-testid="employment-start">
          Ihre Beschäftigung beginnt am {{ start | date:'dd.MM.yyyy' }}. Ab dann steht Ihnen alles zur Verfügung,
          ohne dass Sie sich neu anmelden müssen.
        </p>
      } @else {
        <p class="mt-2 text-sm text-gray-700" data-testid="employment-start">
          Sobald Ihre Beschäftigung beginnt, steht Ihnen alles zur Verfügung.
        </p>
      }
    </div>

    <div class="border-t border-gray-300 px-4 py-6 sm:px-6">
      @if (formsOpen() || contactOpen()) {
        <p class="text-sm text-gray-700">Vor Ihrem ersten Tag können Sie schon Folgendes erledigen:</p>
        <!-- Stacked on phones, side by side from `sm`: the same reflow the two-factor screen uses, so neither
             button shrinks below a comfortable tap size on a narrow viewport. -->
        <div class="mt-4 flex flex-col gap-2 sm:flex-row">
          @if (formsOpen()) {
            <button type="button" (click)="openForms()" data-testid="open-forms"
                    class="inline-flex items-center justify-center rounded-md bg-theme-primary-700 px-3 py-1.5 text-sm font-semibold text-white hover:bg-theme-primary-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-700">
              Formulare ausfüllen
            </button>
          }
          @if (contactOpen()) {
            <button type="button" (click)="openContact()" data-testid="open-contact"
                    class="inline-flex items-center justify-center rounded-md bg-theme-primary-700 px-3 py-1.5 text-sm font-semibold text-white hover:bg-theme-primary-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-700">
              Kontakt verknüpfen
            </button>
          }
        </div>
      } @else {
        <p class="text-sm text-gray-700" data-testid="nothing-to-do">Im Moment ist nichts weiter zu tun.</p>
      }
    </div>

    <div class="border-t border-gray-300 px-4 py-4 sm:px-6">
      <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p class="text-xs text-gray-500">Fragen zu Ihrem Starttermin beantwortet Ihnen Ihre Administration.</p>
        <button type="button" (click)="logout()"
                class="inline-flex items-center justify-center rounded-md border-2 border-gray-200 bg-white px-3 py-1.5 text-sm font-semibold text-gray-700 hover:bg-gray-50">
          Abmelden
        </button>
      </div>
    </div>
  </div>
</div>
